class AppCharacterCounter {
  init () {
    const $characterCounters = document.querySelectorAll('.js-character-counter');

    $characterCounters.forEach(($characterCounter) => {
      const config = {
        minLength: $characterCounter.getAttribute('data-min-length'),
        maxLength: $characterCounter.getAttribute('data-max-length'),
        target: $characterCounter.getAttribute('data-target'),
      };

      const $target = document.querySelector(config.target);

      let currentLength = $target.value.length;

      if (!$target) {
        return;
      }

      this._updateCharacterCounter($characterCounter, currentLength, config);

      $target.addEventListener('input', (event) => {
        currentLength = event.currentTarget.value.length;

        this._updateCharacterCounter($characterCounter, currentLength, config);
      });
    });
  }

  _updateCharacterCounter ($node, currentLength, config) {
    if (config.minLength && config.maxLength) {
      $node.classList.toggle('valid', currentLength >= config.minLength && currentLength <= config.maxLength);
    } else {
      $node.classList.toggle('valid', currentLength >= config.minLength);
    }
    $node.innerHTML = `${currentLength} ${currentLength === 1 ? 'character' : 'characters'}`;

    this._updateSubmitButton($node.closest('form'));
  }

  _updateSubmitButton ($form) {
    const $invalidCharacterCounters = $form.querySelectorAll('.js-character-counter:not(.valid)');
    const $submitButton = $form.querySelector('button[type="submit"]');

    $submitButton.toggleAttribute('disabled', Boolean($invalidCharacterCounters.length));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AppCharacterCounter().init();
});
